import React from 'react'
import"./AboutPhase3.css"
const AboutPhase3 = () => {
  return (
    <div className='aboutPhase3'>
        <h3 className="headtitle3">How I Got Here</h3>
        <p className="paratwo">I am a trained Front-End Developer, who also have acquired a Diploma in  Information Communication Techology .MoreOver,I have acquired skills in HTML ,CSS ,Typescript,JavaScript and ReactJs which have helped me in development of my own websites projects </p>
      
    </div>
  )
}

export default AboutPhase3